import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'

import CtaBlock from '../../molecules/CtaBlock'

const query = graphql`
  query PageTemplatesOceanQuery {
    oceanPosibilities: allFile(
      filter: { relativePath: { eq: "pages/templates/oceanPosibilities.json" } }
    ) {
      edges {
        node {
          childTemplatesJson {
            title
            description
            listDescription
            list
            content {
              title
              subtitle
              actions {
                title
                url
              }
            }
          }
        }
      }
    }
  }
`

export default function OceanPosibilities() {
  const data = useStaticQuery(query)
  const { title, list, description, listDescription, content } =
    data.oceanPosibilities.edges[0].node.childTemplatesJson

  return (
    <CtaBlock
      title={title}
      description={description}
      listDescription={listDescription}
      list={list}
      cta={content}
    />
  )
}
